import Parse from "parse";

import type { SIV_Package } from "./SIV_Package";
import type { OD3_Tenant } from "./OD3_Tenant";

export interface SIV_PackageTextAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  no: number;
  notFoundValues: any;
  package: SIV_Package;
  tenant: OD3_Tenant;
  text?: string | undefined;
}

export class SIV_PackageText extends Parse.Object<SIV_PackageTextAttributes> {
  static className: string = "SIV_PackageText";

  constructor(data?: Partial<SIV_PackageTextAttributes>) {
    super("SIV_PackageText", data as SIV_PackageTextAttributes);
  }

  get no(): number {
    return super.get("no");
  }
  set no(value: number) {
    super.set("no", value);
  }

  get notFoundValues(): any {
    return super.get("notFoundValues");
  }
  set notFoundValues(value: any) {
    super.set("notFoundValues", value);
  }

  get package(): SIV_Package {
    return super.get("package");
  }
  set package(value: SIV_Package) {
    super.set("package", value);
  }

  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }

  get text(): string | undefined {
    return super.get("text");
  }
  set text(value: string | undefined) {
    super.set("text", value);
  }
}

Parse.Object.registerSubclass("SIV_PackageText", SIV_PackageText);
